import isArray from 'lodash/isArray'

// Applies a subscription update to the cached document, with the event's values winning.
// An array result keeps its shape with only the matching element replaced.
export const mergeDocumentUpdate = <T extends { _id?: string }>(
  previous: T | T[] | undefined,
  updated: T | undefined
): T | T[] | undefined => {
  if (updated === undefined) return previous
  if (isArray(previous)) {
    return previous.some((element) => element._id === updated._id)
      ? previous.map((element) => (element._id === updated._id ? { ...element, ...updated } : element))
      : previous
  }
  return previous !== undefined && previous._id === updated._id ? { ...previous, ...updated } : previous
}
